import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { userTypes } from "data/authData";
import { modalInputSx, UserFormField, userUi } from "./userUi";

const typeOptions = [
	{ value: userTypes.internal, title: "Internal", description: "Employees with department and service access" },
	{ value: userTypes.external, title: "External", description: "Partners such as suppliers, stores, or warehouses" },
];

const UserProfileFields = ({ user, setUser, readOnly, lockType, onTypeChange }) => {
	const isExternal = user?.type === userTypes.external;

	const updateField = (key) => (e) => setUser({ ...user, [key]: e.target.value });

	return (
		<>
			{lockType ? (
				<UserFormField label="User type">
					<Select value={user?.type || ""} size="small" disabled sx={modalInputSx} fullWidth>
						<MenuItem value={userTypes.internal}>INTERNAL</MenuItem>
						<MenuItem value={userTypes.external}>EXTERNAL</MenuItem>
					</Select>
				</UserFormField>
			) : (
				<Box sx={{ width: "100%" }}>
					<Typography sx={{ fontSize: 14, fontWeight: 500, color: userUi.textSecondary, mb: 1 }}>
						User type
					</Typography>
					<Box display="flex" gap={1.5} flexWrap="wrap">
						{typeOptions.map((option) => {
							const selected = user?.type === option.value;
							return (
								<Box
									key={option.value}
									onClick={() => {
										if (option.value !== user?.type) onTypeChange?.(option.value);
									}}
									sx={{
										flex: 1,
										minWidth: 180,
										p: 1.5,
										borderRadius: 1.5,
										cursor: "pointer",
										border: `1px solid ${selected ? "#B2DDFF" : userUi.border}`,
										bgcolor: selected ? "#EFF8FF" : "#fff",
									}}>
									<Typography sx={{ fontWeight: 600, fontSize: 14, color: userUi.textPrimary }}>
										{option.title}
									</Typography>
									<Typography sx={{ fontSize: 12, color: userUi.textSecondary, mt: 0.25 }}>
										{option.description}
									</Typography>
								</Box>
							);
						})}
					</Box>
				</Box>
			)}

			{isExternal ? null : (
				<UserFormField label="Employee ID" required>
					<TextField
						size="small"
						value={user?.employee_id || ""}
						onChange={updateField("employee_id")}
						placeholder="Enter employee ID"
						disabled={readOnly}
						required
						sx={modalInputSx}
					/>
				</UserFormField>
			)}

			<UserFormField label="Name" required>
				<TextField
					size="small"
					value={user?.name || ""}
					onChange={updateField("name")}
					placeholder="Enter full name"
					disabled={readOnly}
					required
					sx={modalInputSx}
				/>
			</UserFormField>

			{isExternal ? null : (
				<UserFormField label="Department" required>
					<TextField
						size="small"
						value={user?.department || ""}
						onChange={updateField("department")}
						placeholder="Enter department"
						disabled={readOnly}
						required
						sx={modalInputSx}
					/>
				</UserFormField>
			)}

			{isExternal ? null : (
				<UserFormField label="Designation" required>
					<TextField
						size="small"
						value={user?.designation || ""}
						onChange={updateField("designation")}
						placeholder="Enter designation"
						disabled={readOnly}
						required
						sx={modalInputSx}
					/>
				</UserFormField>
			)}

			<UserFormField label="Mobile no" required>
				<TextField
					size="small"
					value={user?.mobile_no || ""}
					onChange={updateField("mobile_no")}
					placeholder="Enter mobile number"
					disabled={readOnly}
					required
					sx={modalInputSx}
				/>
			</UserFormField>

			<UserFormField label="Email" required>
				<TextField
					size="small"
					type="email"
					value={user?.email || ""}
					onChange={updateField("email")}
					placeholder="Enter email"
					disabled={readOnly}
					required
					sx={modalInputSx}
				/>
			</UserFormField>
		</>
	);
};

export default UserProfileFields;
